import React from 'react';

import { ReactComponent as SVG } from './tick.svg';

const TickIcon = React.memo(() => (
  <div
    style={{
      background: 'transparent',
      color: '#FFD802',
      fontSize: 20,
      left: 16,
      marginLeft: -10,
      marginTop: -10,
      position: 'absolute',
      top: 9,
      verticalAlign: 'middle',
    }}>
    <SVG />
  </div>
));

export default TickIcon;
